import React, { useEffect } from "react";
import { ButtonRenderProps, ContentSection } from "sprint-common-web";

import { useCloudFileDashboard } from "../../common/context/useCloudFileDashboard";
import { useCloudFileDetails } from "../../common/useCloudFileDetails";
import { CloudFileLookupActionsButton } from "./buttons/lookups/CloudFileLookupActionsButton";
import { CloudFileLookupOrdersButton } from "./buttons/lookups/CloudFileLookupOrdersButton";
import { SaveCloudFileAssociationProgressButton } from "./buttons/save-cloud-file/SaveCloudFileAssociationProgressButton";
import { useCloudFileAssociationSection } from "./context/useCloudFileAssociationSection";
import { CloudFileAssociationForm } from "./forms/CloudFileAssociationForm";
import { CloudFileAssociationTabs } from "./tabs/CloudFileAssociationTabs";
import { shouldDisableCloudFileEdit } from "./utils/shouldDisableCloudFileEdit";

interface CloudFileAssociateSectionProps {
    minHeight: number;
}

export const CloudFileAssociateSection = (props: CloudFileAssociateSectionProps): JSX.Element => {
    const { minHeight } = props;

    const { lookupFileRecordId } = useCloudFileDashboard();

    const { init } = useCloudFileAssociationSection();

    const { data: cloudFileDetails } = useCloudFileDetails();

    const isDisabled = !!cloudFileDetails && shouldDisableCloudFileEdit(cloudFileDetails);

    useEffect(() => {
        // TODO: Refactor to fit CloudFileAssociationSection state better so isDisabled is not used here
        if (!cloudFileDetails) return;

        init(cloudFileDetails, isDisabled);
    }, [lookupFileRecordId, isDisabled, cloudFileDetails]);

    const lookupOrdersButton: ButtonRenderProps = {
        render: CloudFileLookupOrdersButton
    };

    const lookupActionsButton: ButtonRenderProps = {
        render: CloudFileLookupActionsButton
    };

    const saveButton: ButtonRenderProps = {
        render: SaveCloudFileAssociationProgressButton
    };

    return (
        <CloudFileAssociationForm>
            <ContentSection
                header="Associate"
                style={{ minHeight }}
                buttons={[lookupOrdersButton, lookupActionsButton, saveButton]}
            >
                <CloudFileAssociationTabs />
            </ContentSection>
        </CloudFileAssociationForm>
    );
};
